import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import SelectDropdown from "../../../components/components-react/SelectDropdown";
import {
  currentMonthNumber,
  currentYear,
} from "../../../components/common-data/Converts";
import { months, years } from "../../../components/common-data/DropdowData";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { toast } from "react-toastify";
import { addGymTarget } from "../../../redux/reducers/postApiSlice";
import { fetchGymData } from "../../../data/APIs";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { gymTarget } from "../../../data/ApiEndpoints";
import { updateGymTarget } from "../../../redux/reducers/putApiSlice";

const validateFormValues = (formValues) => {
  let errors = {};

  if (!formValues.year) {
    errors.year = "Year is required!";
  }

  if (!formValues.monthNo) {
    errors.monthNo = "Month is required!";
  }

  // Check for negative values in all gym targets
  if (formValues.gymTargets && formValues.gymTargets.length > 0) {
    let hasNegativeValues = false;

    formValues.gymTargets.forEach((target, index) => {
      if (parseFloat(target.regular) < 0) {
        hasNegativeValues = true;
        errors.negativeValues = "Negative values are not allowed!";
      }
      if (parseFloat(target.addon_pt) < 0) {
        hasNegativeValues = true;
        errors.negativeValues = "Negative values are not allowed!";
      }
      if (parseFloat(target.addon) < 0) {
        hasNegativeValues = true;
        errors.negativeValues = "Negative values are not allowed!";
      }
    });

    if (hasNegativeValues) {
      errors.negativeValues = "Negative values are not allowed!";
    }
  }

  return errors;
};

const validateFetchValues = (formValues) => {
  let errors = {};

  if (!formValues.year) {
    errors.year = "Year is required!";
  }

  if (!formValues.monthNo) {
    errors.monthNo = "Month is required!";
  }

  return errors;
};

const GymTarAssign = ({
  user,
  allFilters,
  closeModal,
  callFunction,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { loading: postLoading } = useSelector((state) => state.postApi);
  const { loading: putLoading } = useSelector((state) => state.putApi);
  const { data, loading: getLoading } = useSelector((state) => state.common);

  const gymData = useSelector(selectGymData);

  const year = allFilters.selectedYear?.value || currentYear;

  const iniFormValues = {
    monthNo: allFilters.selectedMonth || "",
    year: allFilters.selectedYear || "",
    gymTargets: [],
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [updatingGymId, setUpdatingGymId] = useState(null);

  const iniTbFilters = {
    month: "",
    year: "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);

  const iniTargets = {
    fetchPrevTarget: rowData ? true : false,
    isFetched: false,
    isAvailabe: false,
    fetchedData: rowData
      ? [
          {
            id: rowData?.id || "",
            uid: rowData?.uid || "",
            gym_id: rowData?.gym_id || "",
            gym_name: rowData?.gym_name || "",
            target_value: rowData?.target_value ? rowData.target_value : 0,
            month: rowData?.month || "",
            year: rowData?.year || "",
            regular: rowData?.regular_target ? rowData.regular_target : 0,
            addon: rowData?.addon_target ? rowData.addon_target : 0,
            addon_pt: rowData?.pt_target ? rowData.pt_target : 0,
          },
        ]
      : [],
  };
  const [targetsInfo, setTargetsInfo] = useState(iniTargets);

  const onChangeInput = (e, index) => {
    const { name, value } = e.target;

    // Prevent negative numbers using the input attribute min="0" instead

    setFormValues((prevValues) => {
      const updatedGymTargets = [...prevValues.gymTargets];
      updatedGymTargets[index] = {
        ...updatedGymTargets[index],
        [name]: value,
      };

      // Calculate total target amount
      updatedGymTargets[index].target_value =
        parseInt(updatedGymTargets[index].regular || 0) +
        parseInt(updatedGymTargets[index].addon || 0) +
        parseInt(updatedGymTargets[index].addon_pt || 0);

      return {
        ...prevValues,
        gymTargets: updatedGymTargets,
      };
    });
    setIsSubmit(false);
  };

  const handleInputFocus = (e) => {
    if (e.target.value === "0") {
      e.target.value = "";
    }
  };

  const handleInputBlur = (e, index, name) => {
    if (e.target.value === "") {
      setFormValues((prevValues) => {
        const updatedGymTargets = [...prevValues.gymTargets];
        updatedGymTargets[index] = {
          ...updatedGymTargets[index],
          [name]: 0,
        };
        return {
          ...prevValues,
          gymTargets: updatedGymTargets,
        };
      });
    }
  };

  const onChangeDropdown = (value, name) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setIsSubmit(false);
    setTargetsInfo((prevs) => ({
      ...prevs,
      fetchedData: [],
      isAvailabe: false,
      fetchPrevTarget: false,
      isFetched: false,
    }));
  };

  const onSumitForm = (e, name) => {
    e.preventDefault();

    if (name === "add-post") {
      setFormErrors(validateFormValues(formValues));
      setIsSubmit(true);
    } else {
      setFormErrors(validateFetchValues(formValues));
      const errors = validateFetchValues(formValues);
      setFormErrors(errors);

      if (Object.keys(errors).length === 0) {
        dispatch(
          fetchApiData({
            method: "GET",
            endpoint: gymTarget,
            payload: {
              filters: tbFilters,
            },
            token: user?.token,
          })
        );
        setTargetsInfo((prevs) => ({ ...prevs, isFetched: true }));
      }
    }
  };

  const handleUpdateTarget = (gymTarget) => {
    // Create a temporary form values object to validate just this target
    const tempFormValues = {
      year: formValues.year,
      monthNo: formValues.monthNo,
      gymTargets: [gymTarget],
    };

    const errors = validateFormValues(tempFormValues);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      if (errors.negativeValues) {
        toast.error(errors.negativeValues);
      }
      return;
    }

    setUpdatingGymId(gymTarget.gym_id);

    const requestBody = {
      gym_id: gymTarget.gym_id,
      gym_name: gymTarget.gym_name,
      target_value: gymTarget.target_value,
      year: formValues.year?.value,
      month: formValues.monthNo?.value,
      regular: gymTarget.regular || 0,
      addon: gymTarget.addon || 0,
      addon_pt: gymTarget.addon_pt || 0,
      uid: gymTarget.uid || "",
    };

    dispatch(updateGymTarget({ requestBody, TOKEN: user?.token }))
      .then((result) => {
        if (result?.payload?.status) {
          toast.success(
            `Target updated successfully for ${gymTarget.gym_name}!`
          );
          callFunction();
        } else {
          toast.error(`Failed to update target for ${gymTarget.gym_name}`);
        }
        setUpdatingGymId(null);
      })
      .catch((error) => {
        console.log("Update ERROR => ", error);
        toast.error(
          `Something went wrong while updating ${gymTarget.gym_name}!`
        );
        setUpdatingGymId(null);
      });
  };

  const handleAdd = async (gymTargets, TOKEN) => {
    setIsSubmit(false);

    // Create a temporary form values object for final validation
    const tempFormValues = {
      year: formValues.year,
      monthNo: formValues.monthNo,
      gymTargets: gymTargets,
    };

    const errors = validateFormValues(tempFormValues);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      if (errors.negativeValues) {
        toast.error(errors.negativeValues);
      }
      return;
    }

    try {
      // Filter out targets that already have a UID (they should be updated individually)
      const newTargets = gymTargets.filter((target) => !target.uid);

      if (newTargets.length === 0) {
        toast.info(
          "No new targets to add. Use update buttons for existing targets."
        );
        return;
      }

      // Format the payload according to the requested structure
      const requestBody = {
        month: formValues.monthNo?.value,
        year: formValues.year?.value,
        gyms: newTargets.map((target) => ({
          gym_id: target.gym_id,
          target_value: target.target_value,
          regular: parseInt(target.regular || 0),
          addon: parseInt(target.addon || 0),
          addon_pt: parseInt(target.addon_pt || 0),
        })),
      };

      const result = await dispatch(addGymTarget({ requestBody, TOKEN }));

      if (result?.payload?.status) {
        toast.success("Targets added successfully!");
        setFormValues(iniFormValues);
        setFormErrors({});
        closeModal();
        callFunction();
      } else {
        toast.error("Failed to add targets");
      }
    } catch (error) {
      console.log("handleAdd ERROR => ", error);
      toast.error("Something went wrong!");
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(user?.token));
  }, []);

  // FETCHING DATA FROM rowData || allFilters
  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      monthNo: allFilters.selectedMonth || "",
      year: allFilters.selectedYear || "",
    }));

    if (rowData) {
      setTargetsInfo((prevs) => ({
        ...prevs,
        fetchPrevTarget: true,
        fetchedData: [
          {
            id: rowData?.id || "",
            uid: rowData?.uid || "",
            gym_id: rowData?.gym_id || "",
            gym_name: rowData?.gym_name || "",
            target_value: rowData?.target_value ? rowData.target_value : 0,
            month: rowData?.month || "",
            year: rowData?.year || "",
            regular: rowData?.regular_target ? rowData.regular_target : 0,
            addon: rowData?.addon_target ? rowData.addon_target : 0,
            addon_pt: rowData?.pt_target ? rowData.pt_target : 0,
          },
        ],
      }));
    }
  }, [allFilters, rowData]);
  // ---------------------- FETCHING DATA FROM rowData || allFilters ------------------------

  // SET FILTERS tbFilters FOR FETCH GYM TARGET FROM formValues
  useEffect(() => {
    setTbFilters((prevs) => ({
      ...prevs,
      month: formValues.monthNo?.value || "",
      year: formValues.year?.value || "",
    }));
  }, [formValues.monthNo, formValues.year]);
  // --------------  SET FILTERS tbFilters FOR FETCH GYM TARGET FROM formValues ------------------

  // targetsInfo.fetchedData INTO formValues.gymTargets
  useEffect(() => {
    if (targetsInfo.fetchedData && targetsInfo.fetchedData.length > 0) {
      setFormValues((prevs) => ({
        ...prevs,
        gymTargets: targetsInfo.fetchedData,
      }));
    }
  }, [targetsInfo.fetchedData]);
  // -------------------- targetsInfo.fetchedData INTO formValues ----------------------

  // CALL POST/UPDATE API
  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      handleAdd(formValues.gymTargets, user?.token);
    }
  }, [isSubmit, formErrors]);
  // --------------- CALL POST/UPDATE API ------------------

  // FETCHED GYM TARGET DATA
  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setTargetsInfo((prevs) => ({
        ...prevs,
        fetchedData: data?.data,
        isAvailabe: true,
        fetchPrevTarget: false,
      }));
    } else {
      // If no data is found, create entries for all gyms
      if (gymData && gymData.length > 0) {
        const emptyGymsData = gymData.map((gym) => ({
          gym_id: gym.value,
          gym_name: gym.label,
          target_value: 0,
          regular: 0,
          addon: 0,
          addon_pt: 0,
          month: formValues.monthNo?.value,
          year: formValues.year?.value,
        }));

        setTargetsInfo((prevs) => ({
          ...prevs,
          fetchedData: emptyGymsData,
          isAvailabe: false,
          fetchPrevTarget: false,
        }));
      } else {
        setTargetsInfo((prevs) => ({
          ...prevs,
          fetchedData: [],
          isAvailabe: false,
          fetchPrevTarget: false,
        }));
      }
    }
  }, [data, gymData]);
  // ---------- FETCHED GYM TARGET DATA ------------

  // Check if all gym targets have UIDs
  const allGymsHaveUids =
    formValues.gymTargets.length > 0 &&
    formValues.gymTargets.every((target) => target.uid);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="year" className={`formInputLabel `}>
              Year <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${formErrors.year ? "formError" : ""}`}>
              <SelectDropdown
                options={years}
                selectedOption={formValues.year}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "year")
                }
                name="Year"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="monthNo" className={`formInputLabel `}>
              Month <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.monthNo ? "formError" : ""
              }`}>
              <SelectDropdown
                options={
                  year === currentYear
                    ? months?.filter(
                        (month) => parseInt(month.value) >= currentMonthNumber
                      )
                    : months
                }
                selectedOption={formValues.monthNo}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "monthNo")
                }
                name=""
              />
            </div>
          </div>
        </div>

        {targetsInfo.isFetched &&
        !getLoading &&
        formValues.gymTargets &&
        formValues.gymTargets.length > 0 ? (
          <div className="gym-targets-container m-0">
            <div className="gym-targets-header">
              <div className="gym-name-header">Gym</div>
              <div className="regular-header">Regular Membership</div>
              <div className="pt-header">Personal Training</div>
              <div className="total-header">Total Target</div>
            </div>
            {formValues.gymTargets.map((gymTarget, index) => (
              <div key={gymTarget.gym_id || index}>
                <div className="gym-target-row">
                  <div className="gym-name-field">
                    <input
                      type="text"
                      value={gymTarget.gym_name}
                      disabled
                      className="formInput disabled-input"
                    />
                  </div>
                  <div className="regular-field">
                    <input
                      type="number"
                      placeholder="Enter Regular Amount"
                      className="formInput number-input"
                      name="regular"
                      value={gymTarget.regular}
                      onChange={(e) => onChangeInput(e, index)}
                      onFocus={handleInputFocus}
                      onBlur={(e) => handleInputBlur(e, index, "regular")}
                      min="0"
                    />
                  </div>
                  <div className="pt-field">
                    <input
                      type="number"
                      placeholder="Enter PT Amount"
                      className="formInput number-input"
                      name="addon_pt"
                      value={gymTarget.addon_pt}
                      onChange={(e) => onChangeInput(e, index)}
                      onFocus={handleInputFocus}
                      onBlur={(e) => handleInputBlur(e, index, "addon_pt")}
                      min="0"
                    />
                  </div>
                  <div className="total-field">
                    <input
                      type="number"
                      className="formInput disabled-input number-input"
                      value={gymTarget.target_value}
                      disabled
                    />
                  </div>
                </div>
                {gymTarget.uid && (
                  <div
                    style={{
                      marginTop: "8px",
                      marginBottom: "16px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}>
                    <Button
                      className="updateBtn"
                      variant="warning"
                      onClick={() => handleUpdateTarget(gymTarget)}
                      disabled={updatingGymId === gymTarget.gym_id}>
                      {updatingGymId === gymTarget.gym_id ? (
                        <ReactVortoxSpinner />
                      ) : (
                        "Update"
                      )}
                    </Button>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : null}

        <div
          className="formButtons mt30"
          style={{ justifyContent: "flex-end" }}>
          {!targetsInfo.isFetched ? (
            <Button
              className="saveBtn"
              variant="danger"
              onClick={(e) => onSumitForm(e, "get-fetch")}>
              {getLoading ? <ReactVortoxSpinner /> : "Fetch Target"}
            </Button>
          ) : (
            !allGymsHaveUids && (
              <Button
                className="saveBtn"
                variant="danger"
                onClick={(e) => onSumitForm(e, "add-post")}>
                {postLoading ? <ReactVortoxSpinner /> : "Add Targets"}
              </Button>
            )
          )}
        </div>
      </form>
    </div>
  );
};

export default GymTarAssign;
